<div class="card shadow-sm" style="max-height:calc(100vh - 330px); max-width:800px; overflow-y:scroll">
    <div class="card-body pool-equipment">
        <h3 class="card-title border-bottom pb-2 mb-3">
            Equipment Tracker
        </h3>

        <div *ngFor="let equipmentTrackingModel of equipmentTrackingModels; let idx = index" class="equipment-section">

            <!-- Auto Cover: spec sheet instead of the generic manufacturer/model fields, plus the
                 replacement quote hand-off. See auto-cover-specs for the sections. -->
            <div *ngIf="isAutoCover(equipmentTrackingModel)" class="auto-cover-section">
                <h3 class="section-title border-bottom pb-2 mb-3 d-flex align-items-center justify-content-between"
                    [class.auto-cover-header-toggle]="!isMobile"
                    (click)="toggleAutoCover(equipmentTrackingModel)">
                    <span>
                        {{equipmentTrackingModel.equipmentName}}
                        <i *ngIf="!isMobile && hasAutoCoverSpecs(equipmentTrackingModel)" class="bi bi-check-circle text-success"></i>
                    </span>
                    <i *ngIf="!isMobile" class="bi" [ngClass]="equipmentTrackingModel.showAutoCover ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </h3>

                <!-- Phones get the guided wizard instead of the whole sheet at once -->
                <div *ngIf="isMobile" class="auto-cover-mobile-entry">
                    <p class="text-muted mb-2">
                        <small *ngIf="!hasAutoCoverSpecs(equipmentTrackingModel)">No auto cover specs recorded for this job yet.</small>
                        <small *ngIf="hasAutoCoverSpecs(equipmentTrackingModel)">Specs recorded. Open the tracker to review or update them.</small>
                    </p>
                    <button class="btn btn-primary w-100" (click)="openAutoCoverWizard()">
                        <i class="bi bi-clipboard-check"></i>
                        {{ hasAutoCoverSpecs(equipmentTrackingModel) ? 'Open Auto Cover Tracker' : 'Start Auto Cover Tracker' }}
                    </button>
                </div>

                <!-- Desktop keeps the whole sheet on the page, but collapsed until the header is
                     clicked so it doesn't bury the rest of the equipment list. -->
                <div class="auto-cover-body" *ngIf="!isMobile && equipmentTrackingModel.showAutoCover">
                    <auto-cover-specs [spec]="equipmentTrackingModel.autoCover"
                                      [isMobile]="isMobile"
                                      section="all"></auto-cover-specs>

                    <!-- The quote hand-off and the photo drop sit on one row under the sections, with the
                         photo grid below them. -->
                    <div class="auto-cover-actions mt-3">
                        <div class="auto-cover-quote">
                            <div class="auto-cover-quote-buttons">
                                <!-- The quote is raised against the job's customer, so this needs a job.
                                     Opened from the customer's Assets tab there isn't one. -->
                                <button class="btn btn-outline-primary quote-replacement-button"
                                        [disabled]="!hasAutoCoverSpecs(equipmentTrackingModel) || !jobId"
                                        [title]="!jobId ? 'Open this asset from a job to quote a replacement cover' : ''"
                                        (click)="quoteReplacementCover(equipmentTrackingModel)">
                                    <i class="bi bi-file-earmark-text"></i> Quote Replacement Cover
                                </button>
                                <!-- The other direction: an order this company already built is a better
                                     record of the cover than anything a tech can read off the equipment. -->
                                <button class="btn btn-outline-secondary quote-replacement-button"
                                        [disabled]="fillFromOrderSpinnerStatus === 'spin'"
                                        (click)="fillFromLathamOrder(equipmentTrackingModel)">
                                    <i class="bi bi-link-45deg"></i> Fill From Latham Order
                                </button>
                            </div>
                            <div *ngIf="equipmentTrackingModel.autoCover?.lathamOrderId" class="text-muted mt-1">
                                <small>These specs are linked to a Latham order.</small>
                            </div>
                        </div>

                        <slick-file-drop class="auto-cover-file-drop"
                                         *ngIf="equipmentTrackingModel.documents?.length < maxPhotos(equipmentTrackingModel)"
                                         [ngClass]="{'has-documents': equipmentTrackingModel.documents?.length > 0}"
                                         [displayText]="'Drop files here or click to upload. (Max limit of ' + maxPhotos(equipmentTrackingModel) + ')'"
                                         (filesChanged)="onNewFilesAdded($event, idx)">
                        </slick-file-drop>
                    </div>

                    <div class="mt-3">
                        <slick-file-list [files]="equipmentTrackingModel.documents"
                                         showCheckboxes="false"
                                         [showPhotoGallery]="true"
                                         allowDelete="canDeletePhotos"
                                         (onFileChanged)="onFileChanged($event)"
                                         (onFileDelete)="onFileDeleted($event)"></slick-file-list>
                    </div>

                    <div class="mt-3">
                        <div class="d-flex justify-content-between align-items-center"
                             style="cursor:pointer"
                             (click)="equipmentTrackingModel.showNotes = !equipmentTrackingModel.showNotes">
                            <label class="mb-0 fw-bold">
                                Notes <i *ngIf="equipmentTrackingModel.notes" class="bi bi-check-circle text-success"></i>
                            </label>
                            <i class="bi" [ngClass]="equipmentTrackingModel.showNotes ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                        </div>
                        <div *ngIf="equipmentTrackingModel.showNotes" class="mt-2">
                            <textarea class="form-control" rows="3" placeholder="Notes" [(ngModel)]="equipmentTrackingModel.notes"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex" *ngIf="!isAutoCover(equipmentTrackingModel)">
                <div>
                    <h3 class="section-title border-bottom pb-2 mb-3 d-flex align-items-center justify-content-between">
                        <span>

                            {{equipmentTrackingModel.equipmentName}} <i *ngIf="!equipmentTrackingModel.isDefault" class="text-info far fa-pencil" style="cursor:pointer" (click)="editName(equipmentTrackingModel)"></i>

                        </span>
                        <i *ngIf="!equipmentTrackingModel.isDefault && canDelete" class="text-danger far fa-trash" style="cursor:pointer" (click)="deleteEquipment(idx)"></i>
                    </h3>

                    <div class="form-row mb-2">
                        <label>Manufacturer:</label>
                        <slick-drop-down *ngIf="equipmentTrackingModel.showDropdown === true || equipmentTrackingModel.manufacturer === 'Other'" [items]="equipmentTrackingModel.manufacturerOptions" [ngModel]="equipmentTrackingModel.manufacturer" (onSelect)="onManufacturerChanged($event, equipmentTrackingModel)"></slick-drop-down>
                        <input *ngIf="equipmentTrackingModel.showDropdown === false && equipmentTrackingModel.manufacturer !== 'Other'" class="form-control mt-1" [(ngModel)]="equipmentTrackingModel.manufacturer" />
                    </div>
                    <div *ngIf="equipmentTrackingModel.manufacturer === 'Other'"
                         class="d-flex justify-content-end">

                        <input class="form-control mb-2"
                               [ngStyle]="!isMobile ? { width: '250px' } : null"
                               [(ngModel)]="equipmentTrackingModel.otherManufacturer" />
                    </div>

                    <div class="form-row mb-2">
                        <label>Model:</label>
                        <slick-drop-down *ngIf="equipmentTrackingModel.showDropdown === true && equipmentTrackingModel.equipmentName !== 'Sanitizer'" [items]="equipmentTrackingModel.modelOptions" [(ngModel)]="equipmentTrackingModel.model"></slick-drop-down>
                        <input *ngIf="equipmentTrackingModel.showDropdown === false || equipmentTrackingModel.manufacturer === 'Other' || equipmentTrackingModel.equipmentName === 'Sanitizer'" class="form-control mt-1" [(ngModel)]="equipmentTrackingModel.model" />
                    </div>

                    <div class="form-row mb-2">
                        <label>OEM SKU:</label>
                        <input type="text" class="form-control" [(ngModel)]="equipmentTrackingModel.oemsku" />
                    </div>

                    <div class="form-row mb-2">
                        <label>Serial Number:</label>
                        <input type="text" class="form-control" [(ngModel)]="equipmentTrackingModel.serialNumber" />
                    </div>

                    <div class="form-row mb-2">
                        <label>Install Date:</label>
                        <input slick-date-picker class="form-control" [(ngModel)]="equipmentTrackingModel.installDate" />
                    </div>

                    <div *ngIf="equipmentTrackingModel.equipmentName === 'Heater'" class="form-row mb-2">
                        <label>Heater Type:</label>
                        <slick-drop-down [items]="heaterTypes" [(ngModel)]="equipmentTrackingModel.heaterType" />
                    </div>

                    <div *ngIf="equipmentTrackingModel.equipmentName === 'Heater'" class="form-row mb-2">
                        <label>BTU <span style="font-size: 0.8em">(thousands)</span>:</label>
                        <input type="number" class="form-control" [(ngModel)]="equipmentTrackingModel.btu" />
                    </div>

                    <div *ngIf="equipmentTrackingModel.equipmentName === 'Filter'" class="form-row mb-2">
                        <label>Filter Type:</label>
                        <slick-drop-down [items]="filterTypes" [(ngModel)]="equipmentTrackingModel.filterType" />
                    </div>
                    <!-- Notes Toggle Header -->
                    <div class="mt-3 ms-3">
                        <div class="d-flex justify-content-between align-items-center"
                             style="cursor:pointer"
                             (click)="equipmentTrackingModel.showNotes = !equipmentTrackingModel.showNotes">

                            <label class="mb-0 fw-bold">
                                Notes  <i *ngIf="equipmentTrackingModel.notes" class="bi bi-check-circle text-success"></i>
                            </label>

                            <i class="bi"
                               [ngClass]="equipmentTrackingModel.showNotes ? 'bi-chevron-up' : 'bi-chevron-down'">
                            </i>
                        </div>

                        <!-- Collapsible Notes Area -->
                        <div *ngIf="equipmentTrackingModel.showNotes" class="mt-2">
                            <textarea class="form-control"
                                      rows="3"
                                      placeholder="Notes"
                                      [(ngModel)]="equipmentTrackingModel.notes">
        </textarea>
                        </div>
                    </div>
                </div>

                <div class="ms-2 " style="min-width:350px">
                    <!-- dont use documents-edit here since we need to check if we have to save the pool equipment tracking model first -->
                    <slick-file-list [ngClass]="{'has-max-documents': equipmentTrackingModel.documents?.length === 3}"
                                     [files]="equipmentTrackingModel.documents"
                                     showCheckboxes="false"
                                     [showPhotoGallery]="true"
                                     allowDelete="canDeletePhotos"
                                     (onFileChanged)="onFileChanged($event)"
                                     (onFileDelete)="onFileDeleted($event)"></slick-file-list>
                    <slick-file-drop *ngIf="equipmentTrackingModel.documents?.length < 3"
                                     [ngClass]="{'has-documents': equipmentTrackingModel.documents?.length > 0}"
                                     displayText="Drop files here or click to upload. (Max limit of 3)"
                                     (filesChanged)="onNewFilesAdded($event, idx)">
                    </slick-file-drop>
                </div>
            </div>

        </div>


        <div>

            <button class="btn btn-outline-primary" (click)="showAddNewDialog()">Add Equipment</button>
        </div>
        <div *ngIf="showSaveButton" class="sticky-bottom py-3 sticky-theme-bg">
            <div>
                <button class="btn btn-success save-button" (click)="saveEquipment()" [slick-button-spinner]="equipmentTrackingSpinnerStatus"><i class="bi bi-check-circle"></i> Save Equipment</button>
            </div>
        </div>
    </div>
</div>


<slick-confirm-dialog [width]="dialogWidth" #deleteEquipmentConfirmRef>
    <div class="text-danger">Are you sure you want to delete this equipment?</div>
</slick-confirm-dialog>

<slick-confirm-dialog [width]="dialogWidth" #duplicateFoundRef>
    <div class="text-danger">An equipment with this name already exists</div>
</slick-confirm-dialog>

<slick-dialog header="Add Equipment" [width]="dialogWidth" #newNameDialogRef>
    <label>Equipment Name</label>
    <input type="text" class="form-control" [(ngModel)]="newName" />

    <slick-dialog-footer>
        <button style="width:120px" class="btn btn-outline-success" (click)="addEquipment()">Add</button>
        <button style="width:120px" class="ms-1 btn btn-outline-danger" (click)="cancelAdd()">Cancel</button>
    </slick-dialog-footer>
</slick-dialog>

<slick-dialog header="Edit Equipment" #editNameDialogRef [width]="dialogWidth">
    <label>Equipment Name</label>
    <input type="text" class="form-control" [(ngModel)]="newName" />

    <slick-dialog-footer>
        <button style="width:120px" class="btn btn-outline-success" (click)="onEditNameOk()">Add</button>
        <button style="width:120px" class="ms-1 btn btn-outline-danger" (click)="cancelEdit()">Cancel</button>
    </slick-dialog-footer>
</slick-dialog>
<!-- Picking the order to fill the spec sheet from. Same shape as Link Existing Invoice on the job:
     search box, scrollable result list, one Select button per row. The list endpoint pages at 10, so
     there's a Load More rather than the whole list at once. -->
<slick-dialog #lathamOrderDialogRef
              [resizable]="false"
              [draggable]="false"
              [minimizable]="false"
              header="Select Latham Order"
              [width]="lathamOrderDialogWidth">

    <div class="input-group mt-2">
        <span class="input-group-text"><i class="far fa-search"></i></span>
        <input (keyup)="refreshLathamOrders()"
               [(ngModel)]="lathamOrderSearchString"
               class="form-control"
               placeholder="Order #, PO #, customer name..." />
    </div>

    <div class="my-1">
        <input type="checkbox" [(ngModel)]="showLathamQuotes" (change)="refreshLathamOrders()" />
        Search quotes instead of submitted orders
    </div>

    <div class="latham-order-picker-list">
        <div *ngIf="isLoadingLathamOrders && lathamOrders.length === 0" class="mt-3 text-muted">Loading...</div>

        <div *ngIf="!isLoadingLathamOrders && lathamOrders.length === 0" class="mt-3">
            No {{ showLathamQuotes ? 'quotes' : 'orders' }} found
        </div>

        <div *ngIf="lathamOrders.length > 0" class="d-flex flex-column">
            <div *ngFor="let lathamOrder of lathamOrders"
                 class="border-bottom px-1 mt-1 pb-1 me-2 d-flex"
                 style="line-height: 1.1rem;">
                <div class="d-flex flex-fill flex-column">
                    <h5 class="m-0 p-0 border-0">Order #: {{lathamOrder.orderId}}</h5>
                    <div *ngIf="lathamOrder.homeOwner?.displayName">{{lathamOrder.homeOwner.displayName}}</div>
                    <div *ngIf="lathamOrder.modelType">Model: {{lathamOrder.modelType}}</div>
                    <div *ngIf="lathamOrder.purchaseOrderNumber">PO #: {{lathamOrder.purchaseOrderNumber}}</div>
                    <div *ngIf="lathamOrder.submittedDate">Submitted: {{lathamOrder.submittedDate | date:'M/d/yyyy'}}</div>
                    <div *ngIf="!lathamOrder.submittedDate && lathamOrder.quoteDate">Quoted: {{lathamOrder.quoteDate | date:'M/d/yyyy'}}</div>
                </div>
                <div>
                    <button class="btn btn-sm btn-primary text-nowrap"
                            [disabled]="fillFromOrderSpinnerStatus === 'spin'"
                            [slick-button-spinner]="selectingLathamOrderId === lathamOrder.orderId ? fillFromOrderSpinnerStatus : ''"
                            (click)="selectLathamOrder(lathamOrder)">
                        <i class="far fa-link"></i> Select
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="lathamOrdersHasMore" class="text-center mt-2">
            <button class="btn btn-sm btn-outline-secondary"
                    [disabled]="isLoadingLathamOrders"
                    (click)="loadMoreLathamOrders()">
                {{ isLoadingLathamOrders ? 'Loading...' : 'Load More' }}
            </button>
        </div>
    </div>

    <slick-dialog-footer>
        <button style="width:120px" class="btn btn-outline-danger" (click)="cancelLathamOrderPicker()">
            <i class="bi bi-x-circle"></i> Cancel
        </button>
    </slick-dialog-footer>
</slick-dialog>
